// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-file-list-iRzyPp{border-bottom:1px solid #f0f0f5;width:100%;padding:12px 10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upload-file-list": `upload-file-list-iRzyPp`,
	"uploadFileList": `upload-file-list-iRzyPp`
};
export default ___CSS_LOADER_EXPORT___;
